let baseURL: string

// Check the environment
const _baseURL = localStorage.getItem('baseURL')
if (_baseURL) {
	// Production environment
	baseURL = _baseURL
} else {
	// Development environment
	baseURL = 'https://tikex.com/api'
}

export function fetchWithBaseUrl(
	url: string,
	options: RequestInit = {}
): Promise<Response> {
	console.log('url: ', url)

	// Append the URL to the baseURL
	const fullUrl = `${baseURL}/${url}`

	// Make the fetch request
	return fetch(fullUrl, options)
}
